import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("bidoudou_admin_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const formatPrice = (v) =>
  new Intl.NumberFormat("fr-FR", { style: "currency", currency: "EUR" }).format(v);

export const CATEGORIES = [
  { key: "all", label: "Tous" },
  { key: "bois", label: "Bois" },
  { key: "verre", label: "Verre" },
  { key: "ardoise", label: "Ardoise" },
  { key: "flocage", label: "Flocage" },
];

// Resolve image URL: if it starts with /api/ prepend backend URL,
// otherwise return as-is (external URLs / data URIs).
export const imgUrl = (u) => {
  if (!u) return "";
  if (u.startsWith("http") || u.startsWith("data:")) return u;
  if (u.startsWith("/api/")) return `${BACKEND_URL}${u}`;
  return u;
};

export const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_custom-etch-1/artifacts/j9078sc1_Logo%20bidoudou.jpg";
